import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Medium from "./component/medium";
import Subject from "./component/subject";
import Class from "./component/class";
import Chapter from "./component/chapter";
import QuestionBank from "./component/questionBank";
import QuestionTypes from "./component/QuestionTypes";
import UploadQuestionsTab from "./component/UploadQuestionsTab";
import { setSelectedMedium } from "./redux/boardQuestionSlice";
import { useDispatch } from "react-redux";

export default function BoardDetailsPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const boardName = location.state?.boardName || "Board";
  const [activeTab, setActiveTab] = useState("medium");

  const tabs = [
    { key: "medium", label: "Medium", icon: "📚" },
    { key: "subject", label: "Subject", icon: "📖" },
    { key: "classes", label: "Classes", icon: "🎓" },
    { key: "chapter", label: "Chapter", icon: "📝" },
    { key: "questionBank", label: "Question Bank", icon: "📋" },
    // { key: "uploadQuestions", label: "Upload Questions", icon: "📤" },
    { key: "questionTypes", label: "Question Types", icon: "📄" },
  ];

  const dispatch = useDispatch();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        // padding: "32px",
        padding: "22px",
      }}
    >
      <div
        style={{
          maxWidth: "1400px",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          overflow: "hidden",
        }}
      >
        {/* Header Section */}
        <div
          style={{
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            padding: "20px 32px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          }}
        >
          <div>
            <h1
              style={{
                fontSize: "24px",
                fontWeight: "600",
                color: "white",
                margin: 0,
                marginBottom: "4px",
                letterSpacing: "0.5px",
              }}
            >
              {boardName}
            </h1>
            <p
              style={{
                fontSize: "13px",
                color: "rgba(255,255,255,0.85)",
                margin: 0,
                fontWeight: "400",
              }}
            >
              Manage board resources and question bank
            </p>
          </div>

          <button
            onClick={() => navigate(-1)}
            style={{
              padding: "8px 20px",
              fontSize: "13px",
              borderRadius: "6px",
              border: "1px solid rgba(255,255,255,0.3)",
              background: "rgba(255,255,255,0.15)",
              color: "white",
              cursor: "pointer",
              fontWeight: "500",
              transition: "all 0.3s",
              backdropFilter: "blur(10px)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.25)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.15)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <span>←</span> Back
          </button>
        </div>
        {/* Tabs Navigation */}
        <div
          style={{
            padding: "16px 32px 0",
            backgroundColor: "#f8fafc",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "4px",
              overflowX: "auto",
            }}
          >
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => {
                  setActiveTab(tab.key);
                  dispatch(setSelectedMedium(""));
                }}
                style={{
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: "500",
                  borderRadius: "6px 6px 0 0",
                  border: "none",
                  cursor: "pointer",
                  backgroundColor:
                    activeTab === tab.key ? "white" : "transparent",
                  color: activeTab === tab.key ? "#667eea" : "#64748b",
                  transition: "all 0.2s",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  boxShadow:
                    activeTab === tab.key
                      ? "0 -2px 6px rgba(102, 126, 234, 0.08)"
                      : "none",
                }}
                onMouseEnter={(e) => {
                  if (activeTab !== tab.key) {
                    e.currentTarget.style.backgroundColor =
                      "rgba(102, 126, 234, 0.05)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tab.key) {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }
                }}
              >
                <span style={{ fontSize: "16px" }}>{tab.icon}</span>
                {tab.label}
                {activeTab === tab.key && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: "2px",
                      background:
                        "linear-gradient(90deg, #667eea 0%, #764ba2 100%)",
                    }}
                  />
                )}
              </button>
            ))}
          </div>
        </div>
        {/* Tab Content */}
        <div
          style={{
            padding: "24px",
            minHeight: "500px",
            backgroundColor: "white",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <AnimatePresence mode="wait">
            {activeTab === "medium" && (
              <motion.div
                key="medium"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Medium />
              </motion.div>
            )}
            {activeTab === "subject" && (
              <motion.div
                key="subject"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Subject />
              </motion.div>
            )}
            {activeTab === "classes" && (
              <motion.div
                key="classes"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Class />
              </motion.div>
            )}
            {activeTab === "chapter" && (
              <motion.div
                key="chapter"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <Chapter />
              </motion.div>
            )}
            {activeTab === "questionBank" && (
              <motion.div
                key="questionBank"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <QuestionBank />
              </motion.div>
            )}
            {activeTab === "uploadQuestions" && (
              <motion.div
                key="uploadQuestions"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <UploadQuestionsTab />
              </motion.div>
            )}
            {activeTab === "questionTypes" && (
              <motion.div
                key="questionTypes"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                <QuestionTypes />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
